import React from 'react';
import { eachDayOfInterval, format, isSameDay, addDays, startOfWeek, endOfWeek, differenceInDays } from 'date-fns';

const GanttView = ({ projects }) => {
  const today = new Date();
  const start = startOfWeek(addDays(today, -7));
  const end = endOfWeek(addDays(today, 21));
  const days = eachDayOfInterval({ start, end });
  const totalDays = days.length;

  const getPosition = (dateStr) => {
    if (!dateStr) return 0;
    const date = new Date(dateStr);
    const diff = differenceInDays(date, start);
    return Math.max(0, Math.min(diff, totalDays));
  };

  const getDuration = (startStr, endStr) => {
    if (!startStr || !endStr) return 1;
    const s = new Date(startStr);
    const e = new Date(endStr);
    const diff = differenceInDays(e, s);
    return Math.max(1, diff);
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700 overflow-hidden shadow-sm flex flex-col h-full">
      <div className="flex border-b dark:border-gray-700 overflow-hidden">
        <div className="w-48 flex-shrink-0 p-4 font-semibold text-gray-500 bg-gray-50 dark:bg-gray-900 border-r dark:border-gray-700 z-10">Project</div>
        <div className="flex-1 overflow-x-auto custom-scrollbar">
          <div className="flex" style={{ minWidth: `${totalDays * 40}px` }}>
            {days.map((day) => (
              <div key={day.toISOString()} className={`flex-shrink-0 w-10 text-center border-r dark:border-gray-700 py-2 text-xs ${isSameDay(day, today) ? 'bg-indigo-50 dark:bg-indigo-900/20 font-bold text-indigo-600' : 'text-gray-500'}`}>
                <div className="opacity-50 text-[10px]">{format(day, 'EEE')}</div>
                <div>{format(day, 'd')}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto overflow-x-hidden">
        {projects.map(project => {
          const startPos = getPosition(project.edit_start_date);
          const duration = getDuration(project.edit_start_date, project.delivery_date);
          return (
            <div key={project.id} className="flex border-b dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700/30 transition group">
              <div className="w-48 flex-shrink-0 p-3 text-sm font-medium text-gray-700 dark:text-gray-300 border-r dark:border-gray-700 truncate bg-white dark:bg-gray-800 z-10">
                {project.title}
              </div>
              <div className="flex-1 relative overflow-hidden">
                <div className="absolute inset-0 flex" style={{ minWidth: `${totalDays * 40}px` }}>
                  {days.map((d) => (
                    <div key={d.toISOString()} className="w-10 border-r dark:border-gray-700/50 h-full flex-shrink-0"></div>
                  ))}
                </div>
                {project.edit_start_date && project.delivery_date && (
                  <div 
                    className={`absolute top-2 h-8 rounded-md shadow-sm border border-white/20 flex items-center px-2 text-xs text-white whitespace-nowrap overflow-hidden transition-all hover:brightness-110 cursor-pointer ${project.urgency === 'Critical' ? 'bg-red-500' : project.department === 'Marketing' ? 'bg-purple-500' : 'bg-blue-500'}`} 
                    style={{ left: `${startPos * 40}px`, width: `${duration * 40}px` }}
                    title={`${project.title} (${format(new Date(project.edit_start_date), 'MMM d')} - ${format(new Date(project.delivery_date), 'MMM d')})`}
                  >
                    {project.title}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GanttView;